/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormCreate
 */
export interface FormCreate {
    /**
     * Standard id of the form that is to be created
     * @type {string}
     * @memberof FormCreate
     */
    standardId: string;
}

export function FormCreateFromJSON(json: any): FormCreate {
    return FormCreateFromJSONTyped(json, false);
}

export function FormCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'standardId': json['standard_id'],
    };
}

export function FormCreateToJSON(value?: FormCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'standard_id': value.standardId,
    };
}


